import '@babel/polyfill'
import "isomorphic-fetch";

import Vue from "vue";
import VeeValidate from "vee-validate";
import Notifications from 'vue-notification';
import VueGtm from 'vue-gtm';
import App from "./App.vue";
import router from "./router";
import SocialSharing from "vue-social-sharing";
import { createProvider } from "./vue-apollo";

Vue.use(VeeValidate, SocialSharing);
Vue.use(Notifications);
Vue.use(VueGtm, {
    id: 'GTM-NNF5D4N',
    enabled: true,
    debug: false,
    vueRouter: router,
});
Vue.config.productionTip = false;

new Vue({
    router,
    apolloProvider: createProvider(),
    render: h => h(App)
}).$mount("#app");
